(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7729],{

/***/ 5925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92879);
/* harmony import */ var _Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57271);
/* harmony import */ var _Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Lightbox = function Lightbox(_ref) {
  var images = _ref.images,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      currentPhotoIndex = _useState2[0],
      setCurrentPhotoIndex = _useState2[1];

  var currentPhoto = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return images[currentPhotoIndex];
  }, [images, currentPhotoIndex]);
  var onClickOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
    setIsOpen(true);
    setCurrentPhotoIndex(index);
  }, []);

  var _onMovePrevRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var prev = currentPhotoIndex - 1 < 0 ? images.length - 1 : currentPhotoIndex - 1;
    setCurrentPhotoIndex(prev);
  }, [images, currentPhotoIndex]);

  var _onMoveNextRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var next = currentPhotoIndex + 1 >= images.length ? 0 : currentPhotoIndex + 1;
    setCurrentPhotoIndex(next);
  }, [images, currentPhotoIndex]);

  if (images.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__List),
      children: images.map(function (image, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__Button),
          type: "button",
          onClick: function onClick() {
            return onClickOpen(i);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
            className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__Thumbnail),
            src: image.thumbUrl,
            alt: alt
          })
        }, image.mainUrl);
      })
    }), isOpen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      mainSrc: currentPhoto.mainUrl,
      prevSrc: (images[currentPhotoIndex - 1] || images[images.length - 1]).mainUrl,
      nextSrc: (images[currentPhotoIndex + 1] || images[0]).mainUrl,
      onCloseRequest: function onCloseRequest() {
        return setIsOpen(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return _onMovePrevRequest();
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return _onMoveNextRequest();
      },
      enableZoom: false
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Lightbox);

/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92706);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var LowestPrice = function LowestPrice(props) {
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice), props.className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice__Emphasis),
      children: intl.formatNumber(props.lowestPrice)
    }), intl.formatMessage({
      id: 'merchants.common.lowestPrice.unit'
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LowestPrice);

/***/ }),

/***/ 99744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _resource_id_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/MetaTags.tsx + 1 modules
var MetaTags = __webpack_require__(84915);
// EXTERNAL MODULE: ./src/components/MerchantSite/index.tsx
var MerchantSite = __webpack_require__(7818);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/BooksNotes/index.tsx
var BooksNotes = __webpack_require__(26854);
// EXTERNAL MODULE: ./src/domain/entities/BookingPage.ts
var BookingPage = __webpack_require__(1885);
// EXTERNAL MODULE: ./src/interfaces/merchants/bookings/index.ts
var bookings = __webpack_require__(10592);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/components/Lightbox/index.tsx
var Lightbox = __webpack_require__(5925);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/molecules/common/GoogleMap/GoogleMap.module.scss
var GoogleMap_module = __webpack_require__(97930);
var GoogleMap_module_default = /*#__PURE__*/__webpack_require__.n(GoogleMap_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/molecules/common/GoogleMap/index.tsx







var GoogleMap = function GoogleMap(_ref) {
  var displayName = _ref.displayName,
      mapData = _ref.mapData;
  var classes = classnames_default()((GoogleMap_module_default()).GoogleMap);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [mapData.href ? /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
      className: (GoogleMap_module_default()).GoogleMap__Address,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: mapData.href,
        prefetch: false,
        children: mapData.address_city
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
      className: (GoogleMap_module_default()).GoogleMap__Address,
      children: mapData.address_city
    }), mapData.img_src && /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
      className: (GoogleMap_module_default()).GoogleMap__Image,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: mapData.img_src,
        alt: displayName
      })
    })]
  });
};

/* harmony default export */ var common_GoogleMap = (GoogleMap);
// EXTERNAL MODULE: ./src/molecules/merchant/reviews/ReviewList/index.tsx + 2 modules
var ReviewList = __webpack_require__(98904);
// EXTERNAL MODULE: ./src/atoms/Heading/index.tsx
var Heading = __webpack_require__(44407);
// EXTERNAL MODULE: ./src/organisms/merchants/BaseTemplate/index.tsx + 6 modules
var BaseTemplate = __webpack_require__(74831);
// EXTERNAL MODULE: ./src/molecules/merchant/DescriptionPanel/index.tsx
var DescriptionPanel = __webpack_require__(90455);
// EXTERNAL MODULE: ./src/helpers/merchants/resources/helper.tsx
var helper = __webpack_require__(18904);
// EXTERNAL MODULE: ./src/molecules/merchant/MerchantProfile/index.tsx + 1 modules
var MerchantProfile = __webpack_require__(30446);
// EXTERNAL MODULE: ./src/molecules/merchant/common/buttons/TruncateTextWithButton/index.tsx
var TruncateTextWithButton = __webpack_require__(2667);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/LineTruncate/index.tsx
var LineTruncate = __webpack_require__(56922);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/CourseDetail.module.scss
var CourseDetail_module = __webpack_require__(90501);
var CourseDetail_module_default = /*#__PURE__*/__webpack_require__.n(CourseDetail_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/CourseDetail.tsx








var CourseDetail = function CourseDetail(_ref) {
  var menuName = _ref.menuName,
      price = _ref.price,
      duration = _ref.duration;
  var classes = classnames_default()((CourseDetail_module_default()).CourseDetail);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineTruncate/* SingleLineTruncate */.d, {
      maxLine: 2,
      text: menuName
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (CourseDetail_module_default()).CourseDetail__Detail,
      children: [duration && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (CourseDetail_module_default()).CourseDetail__Time,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "merchants.bookingPages.courseDetail.time",
          values: {
            time: intl.formatNumber(duration / 60)
          }
        })
      }), price && /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "merchants.bookingPages.courseDetail.price",
        values: {
          price: price
        }
      })]
    })]
  });
};

/* harmony default export */ var Appointment_CourseDetail = (CourseDetail);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Course.module.scss
var Course_module = __webpack_require__(63623);
var Course_module_default = /*#__PURE__*/__webpack_require__.n(Course_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Course.tsx











var Course = function Course(_ref) {
  var courseName = _ref.courseName,
      image = _ref.image,
      price = _ref.price,
      text = _ref.text,
      duration = _ref.duration,
      href = _ref.href;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((Course_module_default()).Course);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Course_module_default()).Course__Header,
      children: [image && image.thumb && image.thumb.url && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (Course_module_default()).Course__Image,
        src: image.thumb.url,
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_CourseDetail, {
        menuName: courseName,
        price: price,
        duration: duration
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Course_module_default()).Course__Description,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TruncateTextWithButton/* default */.Z, {
        text: text,
        maxLine: 7
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        legacyBehavior: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          className_Deprecated: (Course_module_default()).Course__Button,
          href: href,
          isGhost: true,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.course.select'
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Appointment_Course = (Course);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Staff.module.scss
var Staff_module = __webpack_require__(29269);
var Staff_module_default = /*#__PURE__*/__webpack_require__.n(Staff_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Staff.tsx










var Staff = function Staff(_ref) {
  var staffName = _ref.staffName,
      image = _ref.image,
      description = _ref.description,
      href = _ref.href;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((Staff_module_default()).Staff);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    "data-style": description ? 'wrap' : 'noWrap',
    children: [image && image.url && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (Staff_module_default()).Staff__Img,
      alt: staffName,
      src: image.url
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Staff_module_default()).Staff__Texts,
      "data-style": image && image.url && 'hasImage',
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (Staff_module_default()).Staff__Name,
        children: staffName
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(TruncateTextWithButton/* default */.Z, {
        className: (Staff_module_default()).Staff__Description,
        text: description,
        maxLine: 7
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Staff_module_default()).Staff__ButtonContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        legacyBehavior: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          href: href,
          isGhost: true,
          className_Deprecated: (Staff_module_default()).Staff__Button,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.staff.select'
          })
        })
      })
    })]
  });
};

/* harmony default export */ var Appointment_Staff = (Staff);
// EXTERNAL MODULE: ./node_modules/lodash-es/camelCase.js + 10 modules
var camelCase = __webpack_require__(20320);
// EXTERNAL MODULE: ./src/molecules/merchant/common/buttons/SwitchContainerButton/SwitchContainerButton.module.scss
var SwitchContainerButton_module = __webpack_require__(38267);
var SwitchContainerButton_module_default = /*#__PURE__*/__webpack_require__.n(SwitchContainerButton_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/common/buttons/SwitchContainerButton/index.tsx


var _excluded = ["label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SwitchContainerButton = function SwitchContainerButton(_ref) {
  var label = _ref.label,
      radioProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var classes = classnames_default()((SwitchContainerButton_module_default()).SwitchContainerButton);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      type: "radio",
      className: classnames_default()((SwitchContainerButton_module_default()).SwitchContainerButton__Input, (0,defineProperty/* default */.Z)({}, (SwitchContainerButton_module_default()).isSelected, radioProps.checked))
    }, radioProps)), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      className: (SwitchContainerButton_module_default()).SwitchContainerButton__Label,
      htmlFor: radioProps.id,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: label || radioProps.value
      })
    })]
  });
};

/* harmony default export */ var buttons_SwitchContainerButton = (SwitchContainerButton);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/SwitchCourseStaff.module.scss
var SwitchCourseStaff_module = __webpack_require__(79038);
var SwitchCourseStaff_module_default = /*#__PURE__*/__webpack_require__.n(SwitchCourseStaff_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/SwitchCourseStaff.tsx








var SwitchCourseStaff = function SwitchCourseStaff(_ref) {
  var selected = _ref.selected,
      onClick = _ref.onClick;
  var intl = (0,useIntl/* default */.Z)();
  var selections = Object.values(SwitchType);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SwitchCourseStaff_module_default()).SwitchCourseStaff,
    children: selections.map(function (selection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(buttons_SwitchContainerButton, {
        name: "switch",
        id: selection,
        label: intl.formatMessage({
          id: "merchants.bookingPages.switchCourseStaff.".concat((0,camelCase/* default */.Z)(selection))
        }),
        onChange: function onChange(e) {
          e.preventDefault();
          onClick(selection);
        },
        checked: selection === selected
      }, selection);
    })
  });
};

/* harmony default export */ var Appointment_SwitchCourseStaff = (SwitchCourseStaff);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/index.module.scss
var index_module = __webpack_require__(35490);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/index.tsx









var SwitchType;

(function (SwitchType) {
  SwitchType["Course"] = "course";
  SwitchType["Staff"] = "staff";
})(SwitchType || (SwitchType = {}));

var Appointment = function Appointment(_ref) {
  var nickname = _ref.nickname,
      resourceId = _ref.resourceId,
      courses = _ref.courses,
      staff = _ref.staff;
  var classes = classnames_default()((index_module_default()).Appointment);
  var bookingPath = "/".concat(nickname, "/").concat(resourceId, "/book");

  var _React$useState = react.useState(SwitchType.Course),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      switchType = _React$useState2[0],
      setSwitchType = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [staff.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_SwitchCourseStaff, {
      selected: switchType,
      onClick: setSwitchType
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).Appointment__Content,
      children: [switchType === SwitchType.Course && courses.length > 0 && courses.map(function (c) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_Course, {
          courseName: c.name,
          image: c.image,
          price: c.price,
          duration: c.duration,
          text: c.description,
          href: "".concat(bookingPath, "?selected_course=").concat(c.id)
        }, c.canonical_id);
      }), switchType === SwitchType.Staff && staff.length > 0 && staff.map(function (s) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_Staff, {
          staffName: s.name,
          image: s.image,
          description: s.description,
          href: "".concat(bookingPath, "?selected_staff=").concat(s.id)
        }, s.canonical_id);
      })]
    })]
  });
};

/* harmony default export */ var components_Appointment = (Appointment);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/MerchantBookingServiceShowPage.module.scss
var MerchantBookingServiceShowPage_module = __webpack_require__(5470);
var MerchantBookingServiceShowPage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantBookingServiceShowPage_module);
// EXTERNAL MODULE: ./src/atoms/icons/StarRating/index.tsx
var StarRating = __webpack_require__(98150);
// EXTERNAL MODULE: ./src/molecules/merchant/common/tags/MerchantTag/index.tsx
var MerchantTag = __webpack_require__(32409);
// EXTERNAL MODULE: ./src/molecules/merchant/common/texts/LowestPrice/index.tsx
var LowestPrice = __webpack_require__(17132);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsReservationButton/MerchantCourseDetailsReservationButton.module.scss
var MerchantCourseDetailsReservationButton_module = __webpack_require__(725);
var MerchantCourseDetailsReservationButton_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsReservationButton_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsReservationButton/index.tsx









var MerchantCourseDetailsReservationButton = function MerchantCourseDetailsReservationButton(_ref) {
  var isBookable = _ref.isBookable,
      nickname = _ref.nickname,
      public_id = _ref.public_id,
      contactUrl = _ref.contactUrl;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton);
  var router = (0,next_router.useRouter)();
  var carryOverQuery = extractCarryOverQueryFromCurrentUrl(router.query);
  var bookingFlowEnterPath = "/".concat(nickname, "/").concat(public_id, "/book");
  var contactPageHref = contactUrl || "/".concat(nickname, "/contact?via=").concat(public_id);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: classes,
    children: isBookable ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: {
        pathname: bookingFlowEnterPath,
        query: carryOverQuery
      },
      prefetch: false,
      passHref: true,
      legacyBehavior: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
        className_Deprecated: (MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton__Button,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.reservation'
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: contactPageHref,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
        href: contactPageHref,
        className_Deprecated: (MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton__Button,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.inquiry'
        })
      })
    })
  });
};

var extractCarryOverQueryFromCurrentUrl = function extractCarryOverQueryFromCurrentUrl(query) {
  var extracted = {};

  var extract = function extract(key) {
    var q = query[key];

    if (typeof q === 'string') {
      extracted[key] = q;
    }
  };

  extract('selected_staff');
  extract('selected_course');
  extract('selected_lesson');
  extract('selected_slot');
  extract('selected_date');
  return extracted;
};

/* harmony default export */ var book_MerchantCourseDetailsReservationButton = (MerchantCourseDetailsReservationButton);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeader/MerchantCourseDetailsHeader.module.scss
var MerchantCourseDetailsHeader_module = __webpack_require__(11901);
var MerchantCourseDetailsHeader_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsHeader_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeader/index.tsx


function MerchantCourseDetailsHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MerchantCourseDetailsHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MerchantCourseDetailsHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MerchantCourseDetailsHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var MerchantCourseDetailsHeader = function MerchantCourseDetailsHeader(props) {
  var merchantSetting = props.merchantSetting,
      isEvent = props.isEvent,
      isFullyBooked = props.isFullyBooked,
      name = props.name,
      tag_names = props.tag_names,
      rate_count = props.rate_count,
      rate = props.rate,
      lowest_price = props.lowest_price;
  var classes = classnames_default()((MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Inner,
      children: [tag_names.map(function (tag, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantTag/* default */.Z, {
          status: tag
        }, i);
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Title,
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__SummaryContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Summary,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: merchantSetting.is_customer_review_active && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating/* default */.Z, {
                  className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__StarRating,
                  rate: rate || 0
                }), rate_count > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__ReviewCount,
                  children: "(".concat(rate_count, ")")
                })]
              })
            }), isEvent && lowest_price && /*#__PURE__*/(0,jsx_runtime.jsx)(LowestPrice/* default */.Z, {
              className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Price,
              lowestPrice: lowest_price
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__ButtonContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(book_MerchantCourseDetailsReservationButton, MerchantCourseDetailsHeader_objectSpread({
              contactUrl: merchantSetting.contact_url
            }, props))
          })]
        })]
      }), isFullyBooked && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Notice,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.notice.fullyBooked'
        })
      })]
    })
  });
};

/* harmony default export */ var components_MerchantCourseDetailsHeader = (MerchantCourseDetailsHeader);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeaderImage/MerchantCourseDetailsHeaderImage.module.scss
var MerchantCourseDetailsHeaderImage_module = __webpack_require__(55960);
var MerchantCourseDetailsHeaderImage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsHeaderImage_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeaderImage/index.tsx






var MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeader = function MerchantCourseDetailsHeader(props) {
  var _classNames;

  var name = props.name,
      _props$primary_image = props.primary_image,
      _props$primary_image$ = _props$primary_image.meta,
      width = _props$primary_image$.width,
      height = _props$primary_image$.height,
      p800x600 = _props$primary_image.p800x600,
      p1280x1280 = _props$primary_image.p1280x1280;
  var classes = classnames_default()((MerchantCourseDetailsHeaderImage_module_default()).MerchantCourseDetailsHeaderImage, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isLargePortrait, width >= 640 && height > width), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isMiddle, width < 640 && width >= 400), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isSmall, width < 400 && width >= 200), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isTiny, width < 200), _classNames));
  var srcUrl = width <= 800 ? p800x600.url : p1280x1280.url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
    className: classes,
    src: srcUrl,
    alt: name
  });
};

/* harmony default export */ var MerchantCourseDetailsHeaderImage = (MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeader);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsStaffList/index.tsx
var MerchantCourseDetailsStaffList = __webpack_require__(42839);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/MerchantBookingServiceShowPage.tsx


var MerchantBookingServiceShowPage_excluded = ["cover_content", "cover_contents_type", "description", "description_text", "primary_image", "is_json_description"];

function MerchantBookingServiceShowPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MerchantBookingServiceShowPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MerchantBookingServiceShowPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MerchantBookingServiceShowPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var MAX_REVIEWS = 3;
var mapPhotoGalleryImageToLightbox = function mapPhotoGalleryImageToLightbox(images) {
  var lightboxImages = images.map(function (image, i) {
    return {
      thumbUrl: findThumb(image),
      mainUrl: findImage(image),
      id: i
    };
  }).filter(function (image) {
    return image.mainUrl !== '' && image.thumbUrl !== '';
  });
  return lightboxImages;
};

var MerchantbookingPageShowPage = function MerchantbookingPageShowPage(_ref) {
  var bookingData = _ref.bookingData,
      isBookable = _ref.isBookable,
      settings = _ref.settings,
      merchantDetail = _ref.merchantDetail,
      categories = _ref.categories,
      courses = _ref.courses,
      staff = _ref.staff,
      reviews = _ref.reviews,
      isCoubicApp = _ref.isCoubicApp;
  var intl = (0,useIntl/* default */.Z)();
  var canShowReviews = merchantDetail.merchant_setting.is_customer_review_active && merchantDetail.rate_count_starby && reviews && reviews.length > 0;

  var cover_content = bookingData.cover_content,
      cover_contents_type = bookingData.cover_contents_type,
      description = bookingData.description,
      description_text = bookingData.description_text,
      primary_image = bookingData.primary_image,
      is_json_description = bookingData.is_json_description,
      headerProps = (0,objectWithoutProperties/* default */.Z)(bookingData, MerchantBookingServiceShowPage_excluded);

  var notes = (0,helper/* useResourceNotes */.dc)(settings);
  var isEvent = bookingData.model_type === BookingPage/* BookingPageScheme.Event */.q0.Event;
  var isFullyBooked = bookingData.status === bookings/* MerchantBookingStatus.FullyBooked */._z.FullyBooked; // explore掲載専用マーチャントの場合、予約に関しての注意事項が紛らわしいので見せない。(予約導線はクービック内に無い為)

  var attentionForBookingVisible = !merchantDetail.merchant_setting.is_explore_only;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BaseTemplate/* default */.Z, {
    footerProps: {
      categories: categories
    },
    merchantDetail: merchantDetail,
    bookingPageIsBookable: isBookable,
    isCoubicApp: isCoubicApp,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_MerchantCourseDetailsHeader, MerchantBookingServiceShowPage_objectSpread({
          isBookable: isBookable,
          merchantSetting: merchantDetail.merchant_setting,
          isEvent: isEvent,
          isFullyBooked: isFullyBooked
        }, headerProps))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__HeroImage,
        children: [cover_contents_type === 'upload_image' && primary_image && /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsHeaderImage, {
          name: headerProps.name,
          primary_image: primary_image
        }), cover_contents_type === 'embed' && cover_content && cover_content.embed && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Embed,
          dangerouslySetInnerHTML: {
            __html: cover_content.embed
          }
        })]
      }), (is_json_description && description || description_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionPanel/* default */.Z, {
          description: description,
          description_text: description_text,
          is_json_description: is_json_description
        })
      }), isBookable && courses.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'books.formsLabel.appointment'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Appointment, {
          nickname: merchantDetail.public_id,
          resourceId: bookingData.public_id,
          courses: courses,
          staff: staff
        })]
      }), isEvent && staff.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'books.formsLabel.staff'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsStaffList/* default */.Z, {
          staff: staff
        })]
      }), attentionForBookingVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'books.formsLabel.attentionForBooking'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BooksNotes/* default */.Z, {
          notes: notes
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__ButtonContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(book_MerchantCourseDetailsReservationButton, MerchantBookingServiceShowPage_objectSpread({
            isBookable: isBookable,
            contactUrl: merchantDetail.merchant_setting.contact_url
          }, bookingData))
        })]
      }), bookingData.map_widget && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'merchants.details.access'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_GoogleMap, {
          displayName: merchantDetail.display_name,
          mapData: bookingData.map_widget
        })]
      }), bookingData.photo_gallery_images.length >= 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.photoGallery'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Lightbox/* default */.Z, {
          images: mapPhotoGalleryImageToLightbox(bookingData.photo_gallery_images),
          alt: bookingData.name
        })]
      }), canShowReviews && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'reviews.title'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewList/* default */.Z, {
          reviews: reviews,
          merchantDetail: merchantDetail,
          max: MAX_REVIEWS,
          rate_count_starby: merchantDetail.rate_count_starby,
          showHeader: true
        }), reviews.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/".concat(merchantDetail.public_id, "/reviews"),
          prefetch: false,
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__ReviewLink,
          children: intl.formatMessage({
            id: 'merchants.details.showMoreReviews'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.storeData'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantProfile/* default */.Z, {
          merchantDetail: merchantDetail
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__BackToTopButtonSection,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
            className_Deprecated: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__BackToTopButton,
            isGhost: true,
            isFull: true,
            href: "/".concat(merchantDetail.public_id),
            buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
            children: intl.formatMessage({
              id: 'merchants.details.backToMerchantTop'
            }, {
              displayName: merchantDetail.display_name
            })
          })
        })]
      })]
    })
  });
}; //  findThumb is helper


function findThumb(data) {
  if (data.image.thumb && data.image.thumb.url) {
    return data.image.thumb.url || '';
  }

  if (data.image.square && data.image.square.url) {
    return data.image.square.url || '';
  }

  if (data.image.p800x600 && data.image.p800x600.url) {
    return data.image.p800x600.url || '';
  }

  if (data.image.p1280x1280 && data.image.p1280x1280.url) {
    return data.image.p1280x1280.url || '';
  }

  if (data.image && data.image.url) {
    return data.image.url || '';
  }

  return '';
} //  findImage is helper


function findImage(image) {
  if (image.image.p1280x1280 && image.image.p1280x1280.url) {
    return image.image.p1280x1280.url || '';
  }

  if (image.image.p800x600 && image.image.p800x600.url) {
    return image.image.p800x600.url || '';
  }

  if (image.image && image.image.url) {
    return image.image.url || '';
  }

  if (image.image.square && image.image.square.url) {
    return image.image.square.url || '';
  }

  if (image.image.thumb && image.image.thumb.url) {
    return image.image.thumb.url || '';
  }

  return '';
}

/* harmony default export */ var MerchantBookingServiceShowPage = (MerchantbookingPageShowPage);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsPageProtected/index.tsx
var MerchantCourseDetailsPageProtected = __webpack_require__(15572);
// EXTERNAL MODULE: ./src/templates/ErrorTemplate/index.tsx + 2 modules
var ErrorTemplate = __webpack_require__(80806);
// EXTERNAL MODULE: ./src/infrastructure/api/backend/explore_api.ts + 1 modules
var explore_api = __webpack_require__(72314);
// EXTERNAL MODULE: ./src/infrastructure/repositories/BookingPageRepository.ts
var BookingPageRepository = __webpack_require__(67988);
// EXTERNAL MODULE: ./src/redux/reducers/merchants/resources/books/helper.ts + 1 modules
var books_helper = __webpack_require__(83929);
// EXTERNAL MODULE: ./src/infrastructure/api/index.ts + 2 modules
var api = __webpack_require__(31735);
// EXTERNAL MODULE: ./src/utils/sanitizeResourcePublicId.ts
var sanitizeResourcePublicId = __webpack_require__(29832);
// EXTERNAL MODULE: ./src/hooks/gtm/index.ts
var gtm = __webpack_require__(51295);
;// CONCATENATED MODULE: ./src/pages/[publicId]/[resource_id]/index.tsx




function _resource_id_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _resource_id_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _resource_id_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _resource_id_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var toThumbnailUrl = function toThumbnailUrl(args) {
  var bookingData = args.bookingData,
      merchantDetail = args.merchantDetail;

  if (bookingData.primary_image && bookingData.primary_image.square) {
    return bookingData.primary_image.square.url;
  } // 動画のサムネイル


  if (bookingData.cover_content) {
    return bookingData.cover_content.thumbnail_url;
  } // nothing (PhotoGallaryから一枚昇格してメインイメージとして表示される)


  return merchantDetail.cover_image.url;
};

var MerchantResourceComponent = function MerchantResourceComponent(props) {
  var _state$merchantDetail;

  var state = props.state,
      isBookable = props.isBookable;
  (0,gtm/* usePushMerchantDataLayerEffect */.O)({
    visit_merchant_id: state === null || state === void 0 ? void 0 : (_state$merchantDetail = state.merchantDetail) === null || _state$merchantDetail === void 0 ? void 0 : _state$merchantDetail.id
  });

  if (!state) {
    return null;
  }

  var merchantDetail = state.merchantDetail,
      categories = state.categories,
      category = state.category,
      reviews = state.reviews,
      bookingData = state.bookingData,
      settings = state.settings,
      courses = state.courses,
      staff = state.staff;

  if (merchantDetail && category && reviews) {
    var _merchantDetail$seo_s, _merchantDetail$seo_s2, _merchantDetail$favic;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: state.bookingData.name,
        description: state.bookingData.description_text,
        keywords: ((_merchantDetail$seo_s = merchantDetail.seo_setting) === null || _merchantDetail$seo_s === void 0 ? void 0 : _merchantDetail$seo_s.keyword) || '',
        thumbnailUrl: toThumbnailUrl({
          merchantDetail: merchantDetail,
          bookingData: state.bookingData
        }),
        currentUrl: "".concat(MetaTags/* COUBIC_ORIGIN */._, "/").concat(merchantDetail.public_id, "/").concat(state.bookingData.public_id),
        noIndex: (_merchantDetail$seo_s2 = merchantDetail.seo_setting) === null || _merchantDetail$seo_s2 === void 0 ? void 0 : _merchantDetail$seo_s2.no_index,
        googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id,
        faviconImageUrl: merchantDetail === null || merchantDetail === void 0 ? void 0 : (_merchantDetail$favic = merchantDetail.favicon_image) === null || _merchantDetail$favic === void 0 ? void 0 : _merchantDetail$favic.url
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantBookingServiceShowPage, {
        bookingData: bookingData,
        isBookable: isBookable,
        reviews: reviews,
        settings: settings,
        merchantDetail: merchantDetail,
        categories: categories,
        courses: courses,
        staff: staff,
        isCoubicApp: props.isCoubicApp
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTemplate/* default */.Z, {
    statusCode: 404
  });
};

var MerchantResource = function MerchantResource(props) {
  var _state$merchantDetail2, _state$merchantDetail3;

  var session = props.session,
      token = props.token,
      requestId = props.requestId,
      isPasswordProtected = props.isPasswordProtected,
      isBookable = props.isBookable,
      isUnpublishedSite = props.isUnpublishedSite,
      resourcePublicId = props.resourcePublicId,
      merchantPublicId = props.merchantPublicId,
      pageProps = props.pageProps,
      isCoubicApp = props.isCoubicApp;

  var _useState = (0,react.useState)(isPasswordProtected),
      passwordProtected = _useState[0],
      setPasswordProtected = _useState[1];

  var _useState2 = (0,react.useState)(pageProps),
      state = _useState2[0],
      setState = _useState2[1];

  var onPasswordSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(success) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!success) {
                _context.next = 7;
                break;
              }

              setPasswordProtected(false); // FIXME: ここちゃんとrouter使ってページ遷移させるべき

              _context.t0 = setState;
              _context.next = 5;
              return fetchPageProps({
                session: session,
                token: token,
                requestId: requestId,
                resourcePublicId: resourcePublicId,
                merchantPublicId: merchantPublicId
              });

            case 5:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPasswordSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantSite/* MerchantSite */.Z, {
    isProtected: passwordProtected,
    protectedElement: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        noIndex: true,
        opgDisabled: true,
        googleAnalyticsFourTrackingId: state === null || state === void 0 ? void 0 : (_state$merchantDetail2 = state.merchantDetail) === null || _state$merchantDetail2 === void 0 ? void 0 : _state$merchantDetail2.available_google_analytics_four_tracking_id
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsPageProtected/* default */.Z, {
        publicId: merchantPublicId,
        servicePublicId: resourcePublicId,
        onSubmit: onPasswordSubmit,
        session: session,
        token: token,
        requestId: requestId
      })]
    }),
    isUnPublished: isUnpublishedSite !== null && isUnpublishedSite !== void 0 ? isUnpublishedSite : false,
    isMerchantInfoExist: !!(state !== null && state !== void 0 && state.merchantDetail),
    logoImage: (state === null || state === void 0 ? void 0 : (_state$merchantDetail3 = state.merchantDetail) === null || _state$merchantDetail3 === void 0 ? void 0 : _state$merchantDetail3.logo_image) || null,
    merchantPublicId: merchantPublicId,
    isCoubicApp: isCoubicApp,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantResourceComponent, {
      state: state,
      isBookable: isBookable,
      isCoubicApp: isCoubicApp
    })
  });
};

var fetchPageProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(args) {
    var session, token, requestId, resourcePublicId, merchantPublicId, repository, sanitizedResourcePublicId, _yield$Promise$all$ca, _yield$Promise$all$ca2, merchantDetailResponse, categories, bookingData, settings, review, merchant, category, pageProps, courses, staff;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            session = args.session, token = args.token, requestId = args.requestId, resourcePublicId = args.resourcePublicId, merchantPublicId = args.merchantPublicId;
            repository = (0,BookingPageRepository/* BookingPageRepositoryForSSR */.SC)(session, token, requestId);
            sanitizedResourcePublicId = (0,sanitizeResourcePublicId/* sanitizeResourcePublicId */.k)(resourcePublicId);
            _context2.next = 5;
            return Promise.all([// Layoutで取得している部分を徐々に置き換え中
            (0,api/* fetchMerchantDetail */.uY)({
              session: session,
              token: token,
              requestId: requestId,
              merchantPublicId: merchantPublicId
            }), (0,explore_api/* allCategoriesCache */.Cp)(), // axios.getだとcookieが載らないので、BookingPageRepositoryForSSR経由で取得
            repository.Find(merchantPublicId, sanitizedResourcePublicId), repository.ConfirmData(merchantPublicId, sanitizedResourcePublicId), (0,api/* fetchMerchantReviewsForSSR */._x)({
              session: session,
              token: token,
              requestId: requestId,
              merchantPublicId: merchantPublicId,
              page: 1,
              perPage: 10
            })])["catch"](function (err) {
              throw err;
            });

          case 5:
            _yield$Promise$all$ca = _context2.sent;
            _yield$Promise$all$ca2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all$ca, 5);
            merchantDetailResponse = _yield$Promise$all$ca2[0];
            categories = _yield$Promise$all$ca2[1];
            bookingData = _yield$Promise$all$ca2[2];
            settings = _yield$Promise$all$ca2[3];
            review = _yield$Promise$all$ca2[4];
            merchant = merchantDetailResponse.merchant;

            if (!merchant) {
              _context2.next = 19;
              break;
            }

            _context2.next = 16;
            return (0,explore_api/* getCategory */.n3)(merchant.category_id);

          case 16:
            _context2.t0 = _context2.sent;
            _context2.next = 20;
            break;

          case 19:
            _context2.t0 = undefined;

          case 20:
            category = _context2.t0;
            pageProps = {
              merchantDetail: merchant,
              category: category,
              categories: categories,
              bookingData: bookingData,
              settings: (0,books_helper/* toSettingConfirm */.fi)(settings),
              reviews: review === null || review === void 0 ? void 0 : review.data,
              courses: [],
              staff: [],
              isBookable: false
            }; // FIXME: 本当はV2側でisStaffSelectableを考慮したほうがいいかもしれないが他に影響出るかもなのでここでハンドリングする

            if (!(pageProps.bookingData.model_type === bookings/* BookingPageScheme.ASSIGN */.q0.ASSIGN || pageProps.bookingData.model_type === bookings/* BookingPageScheme.AVAILABILITY */.q0.AVAILABILITY)) {
              _context2.next = 27;
              break;
            }

            _context2.next = 25;
            return repository.SearchCourse(merchantPublicId, sanitizedResourcePublicId);

          case 25:
            courses = _context2.sent;
            pageProps = _resource_id_objectSpread(_resource_id_objectSpread({}, pageProps), {}, {
              courses: courses.data
            });

          case 27:
            if (!(pageProps.bookingData.model_type === bookings/* BookingPageScheme.ASSIGN */.q0.ASSIGN && pageProps.bookingData.staff_selectable || pageProps.bookingData.model_type === bookings/* BookingPageScheme.EVENT */.q0.EVENT)) {
              _context2.next = 32;
              break;
            }

            _context2.next = 30;
            return repository.SearchStaff(merchantPublicId, sanitizedResourcePublicId);

          case 30:
            staff = _context2.sent;
            pageProps = _resource_id_objectSpread(_resource_id_objectSpread({}, pageProps), {}, {
              staff: staff.data
            });

          case 32:
            return _context2.abrupt("return", _resource_id_objectSpread({}, pageProps));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchPageProps(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var __N_SSP = true;
/* harmony default export */ var _resource_id_ = (MerchantResource);

/***/ }),

/***/ 94348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/[resource_id]",
      function () {
        return __webpack_require__(99744);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Lightbox":"Lightbox_Lightbox__l_1TM","Lightbox__List":"Lightbox_Lightbox__List__Kn_L0","Lightbox__Button":"Lightbox_Lightbox__Button__lOs6j","Lightbox__Thumbnail":"Lightbox_Lightbox__Thumbnail__BOB2r"};

/***/ }),

/***/ 97930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GoogleMap":"GoogleMap_GoogleMap___Z0o8","GoogleMap__Address":"GoogleMap_GoogleMap__Address__6pasU","GoogleMap__Image":"GoogleMap_GoogleMap__Image__0ioqr"};

/***/ }),

/***/ 38267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SwitchContainerButton":"SwitchContainerButton_SwitchContainerButton__jp2tc","SwitchContainerButton__Label":"SwitchContainerButton_SwitchContainerButton__Label__dfPY_","SwitchContainerButton__Input":"SwitchContainerButton_SwitchContainerButton__Input__3EhUt","isSelected":"SwitchContainerButton_isSelected__no9BV"};

/***/ }),

/***/ 92706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__ZU1tL","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__5HvM8"};

/***/ }),

/***/ 725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsReservationButton":"MerchantCourseDetailsReservationButton_MerchantCourseDetailsReservationButton__rxzLg","MerchantCourseDetailsReservationButton__Button":"MerchantCourseDetailsReservationButton_MerchantCourseDetailsReservationButton__Button__xbTyW"};

/***/ }),

/***/ 5470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantBookingServiceShowPage":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Ahsrg","MerchantBookingServiceShowPage__Heading":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Heading__NAd6Y","MerchantBookingServiceShowPage__HeroImage":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__HeroImage__0lR4y","MerchantBookingServiceShowPage__Embed":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Embed__s35hg","MerchantBookingServiceShowPage__Section":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Section__X7l4N","MerchantBookingServiceShowPage__ReviewLink":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ReviewLink__tRi5t","MerchantBookingServiceShowPage__ButtonContainer":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ButtonContainer__7_akw","MerchantBookingServiceShowPage__ReviewLinkIcon":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ReviewLinkIcon__PL1_W","MerchantBookingServiceShowPage__MerchantProfileSection":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__MerchantProfileSection__ppFlL","MerchantBookingServiceShowPage__BackToTopButtonSection":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__BackToTopButtonSection__1lv7I","MerchantBookingServiceShowPage__BackToTopButton":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__BackToTopButton__GAab9"};

/***/ }),

/***/ 63623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Course":"Course_Course__zZyX8","Course__Header":"Course_Course__Header__OHrzj","Course__Image":"Course_Course__Image__qkZ9Z","Course__Description":"Course_Course__Description__EzKb6","Course__Button":"Course_Course__Button__88Itg"};

/***/ }),

/***/ 90501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CourseDetail":"CourseDetail_CourseDetail__CI2Jz","CourseDetail__Detail":"CourseDetail_CourseDetail__Detail__8OP9U","CourseDetail__Time":"CourseDetail_CourseDetail__Time__N8AcN"};

/***/ }),

/***/ 29269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Staff":"Staff_Staff__h9tHC","Staff__Img":"Staff_Staff__Img__7gZeh","Staff__Texts":"Staff_Staff__Texts__kGi0T","Staff__Name":"Staff_Staff__Name__gFvNx","Staff__Description":"Staff_Staff__Description__Ql_lj","Staff__ButtonContainer":"Staff_Staff__ButtonContainer__aLXx1","Staff__Button":"Staff_Staff__Button__Tz1Pl"};

/***/ }),

/***/ 79038:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SwitchCourseStaff":"SwitchCourseStaff_SwitchCourseStaff__gjfjA"};

/***/ }),

/***/ 35490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Appointment":"Appointment_Appointment__JlQ7_","Appointment__Content":"Appointment_Appointment__Content__uTUnZ"};

/***/ }),

/***/ 11901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsHeader":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__G8Bif","MerchantCourseDetailsHeader__Inner":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Inner__7ACcw","MerchantCourseDetailsHeader__Header":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Header__a2hwP","MerchantCourseDetailsHeader__Title":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Title__9kUVt","MerchantCourseDetailsHeader__Summary":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Summary__pbhNl","MerchantCourseDetailsHeader__StarRating":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__StarRating__Olzcb","MerchantCourseDetailsHeader__ReviewCount":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__ReviewCount__FSQAJ","MerchantCourseDetailsHeader__Price":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Price__FCIxh","MerchantCourseDetailsHeader__Notice":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Notice__svsfo","MerchantCourseDetailsHeader__ButtonContainer":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__ButtonContainer__3rLZ6","MerchantCourseDetailsHeader__SummaryContainer":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__SummaryContainer__mLO0y"};

/***/ }),

/***/ 55960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsHeaderImage":"MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeaderImage__odeb0","isLargePortrait":"MerchantCourseDetailsHeaderImage_isLargePortrait__rpZhL","isMiddle":"MerchantCourseDetailsHeaderImage_isMiddle__k6kN8","isSmall":"MerchantCourseDetailsHeaderImage_isSmall__hdyJs","isTiny":"MerchantCourseDetailsHeaderImage_isTiny__cIXIN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [56,2595,8888,8829,2218,4778,320,3253,648,301,1080,9836,4604,806,719,3714,4831,6339,8769,6034,7994,512,9774,2888,179], function() { return __webpack_exec__(94348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);